import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { IUIRuntime } from '@cian/mf-registry/browser';
import { IMicrofrontendManifest, IRegistry } from '@cian/mf-registry/shared';

import {
  fetchGetNewbuildingBrokerModalsMicroFrontend,
  TGetNewbuildingBrokerModalsMicroFrontendResponse,
} from '../../repositories/newbuilding-broker-modals-micro-frontend/v1/get-newbuilding-broker-modals-micro-frontend';

interface IParams {
  httpApi: IHttpApi;
  logger: ILogger;
  microfrontendsRegistry: IRegistry;
}

export const registerNewbuildingBrokerModalsMicroFrontendManifest = async (
  params: IParams,
): Promise<IMicrofrontendManifest | null> => {
  const { httpApi, logger, microfrontendsRegistry } = params;

  try {
    const {
      response: { manifest },
    }: TGetNewbuildingBrokerModalsMicroFrontendResponse = await fetchGetNewbuildingBrokerModalsMicroFrontend({
      httpApi,
    });

    const image = microfrontendsRegistry.register(manifest);

    if (typeof window !== 'undefined') {
      const runtime = image.runtimeStrict<IUIRuntime>(manifest.runtimeName);
      await runtime.ensure();
    }

    return manifest;
  } catch (error) {
    logger.error(error, { domain: 'services#registerNewbuildingBrokerModalsMicroFrontendManifest()' });

    return null;
  }
};
